/**
 * @desc 批量下载附件
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CustomsClearanceDownloadResponseDto>;
export function request(
  body: defs.tms.CustomsClearanceRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/downloadFileList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
